export var KiteTransactionType;
(function (KiteTransactionType) {
    KiteTransactionType["BUY"] = "BUY";
    KiteTransactionType["SELL"] = "SELL";
})(KiteTransactionType || (KiteTransactionType = {}));
export var KiteProductType;
(function (KiteProductType) {
    KiteProductType["NRML"] = "NRML";
    KiteProductType["MIS"] = "MIS";
    KiteProductType["CNC"] = "CNC";
})(KiteProductType || (KiteProductType = {}));
export var KiteOrderType;
(function (KiteOrderType) {
    KiteOrderType["MARKET"] = "MARKET";
    KiteOrderType["LIMIT"] = "LIMIT";
    KiteOrderType["SL"] = "SL";
    KiteOrderType["SL-M"] = "SL-M";
})(KiteOrderType || (KiteOrderType = {}));
export var KiteExchange;
(function (KiteExchange) {
    KiteExchange["NSE"] = "NSE";
    KiteExchange["BSE"] = "BSE";
    KiteExchange["NFO"] = "NFO";
    KiteExchange["BFO"] = "BFO";
    KiteExchange["MCX"] = "MCX";
    KiteExchange["CDS"] = "CDS";
})(KiteExchange || (KiteExchange = {}));
//# sourceMappingURL=kite.js.map